import { useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import type { TSYSTEM_PERMISSIONS } from '../constants/permissions';

export const usePermissions = () => {
  const allowedPermissions = useSelector((state: RootState) => state.auth.allowedPermissions) || [];
  const isSuperadmin = useSelector((state: RootState) => state.auth.isSuperadmin) || false;

  const hasPermission = (permission: TSYSTEM_PERMISSIONS) => {
    return allowedPermissions.includes(permission);
  };

  return {
    isSuperadmin,
    allowedPermissions,
    hasPermission,
    canReadProducts: hasPermission('product:read'),
    canManageProducts: hasPermission('product:create') || hasPermission('product:update'),
    canReadOrders: hasPermission('order:read'),
    canManageOrders: hasPermission('order:create') || hasPermission('order:update'),
    canReadFinance: hasPermission('finance:read'),
    canReadLocations: hasPermission('location:read'),
  };
};
